<template>
	<div class="full page_container">

		<el-tabs class="tabs flex" v-model="activeName" type="border-card">
			<el-tab-pane label="定制产品咨询" v-if="findChildren(163)!==-1" name="customizedproductconsult" style="height: 100%;">
				<customizedproductconsult-index />
			</el-tab-pane>
			<el-tab-pane label="定制产品订单" v-if="findChildren(164)!==-1" name="customizedproductorder" style="height: 100%;">
				<customizedproductorder-index />
			</el-tab-pane>		
		</el-tabs>


	</div>
</template>
<style scoped>
	.departmen_container {
		padding: 10px;
		box-sizing: border-box;
		flex-direction: column;
	}

	.tabs {
		flex-direction: column;
		position: relative;
		width: 100%;
		height: 100%;
	}
</style>
<script>
	import customizedproductconsultIndex from './customizedproductconsult/index.vue'
	import customizedproductorderIndex from './customizedproductorder/index.vue'


	export default {
		props: {

		},
		data() {
			return {
				activeName: '',
				activeIndex: '',
				departmentChildren: []
			}
		},
		watch: {

		},
		created() {
			this.departmentChildren = this.$router.currentRoute.meta.children
			if (this.departmentChildren.length != 0) {
				this.activeName = this.departmentChildren[0].controller
				//this.activeName = 'purchasestockbill'
			}
			//console.log(this.departmentChildren)
		},
		mounted() {

		},
		computed: {

		},

		methods: {
			findChildren(id) {
				return this.departmentChildren.findIndex((item) => {
					return item.id == id
				})
			}
		},
		components: {
			customizedproductconsultIndex,
			customizedproductorderIndex

		}
	}
</script>